module.exports = __webpack_public_path__ + "intacta.jpg?7f0cc9bb88adcb0cd16a37a86a1f66bf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/intacta.jpg
// module id = 123
// module chunks = 0